import { db } from "@/firebase/init"
import swal from 'sweetalert2';
export default {
    data(){
        return{
            usernames: [],
            user_name: null,
            primaryDomain: '',
            alreadyAccountFlag: false,
            hostingAccounts:[],
            uId:'',
        }
    },
    methods:{
        async getHostingAccounts(userUId){
            await this.$store.dispatch("async/stateUpdate", { state: false}, { root: true });
            const uid = userUId || this.userUId
            await db.collection("users").doc(uid).update({
                emailSetupFlag: true,
            });
            if (userUId) {
                this.emailSetup = true
                this.fetchUserDetails(userUId)
            }
            this.$store.state.emailSetup = true;
            await this.$store.dispatch("async/stateUpdate", { state: true, text: "" }, { root: true });
            // if(userUId){
            //     const doc =  await db.collection("hostingAccounts")
            //         .doc(userUId)
            //         .get();
            //     this.hostingAccounts = doc.data().accounts;
            //     this.uId = userUId;
            // }else{
            //     this.hostingAccounts = await this.$store.getters["hosting/accounts"];
            //     this.uId = this.userUId;
            // }
            // await this.checkAccounts();
        },
        async checkAccounts(){
            await this.$store.dispatch("async/stateUpdate", { state: false, text:  `Checking for account...`}, { root: true });
            for(let account of this.hostingAccounts){
                let resp = await this.$http.post('email/list-account',{
                    grant_type:'token',
                    domain:account.primary.domain,
                    searchType:'domain'
                });
                console.log(resp.data.msg.data);
                if(resp.data.msg.data){
                    if(account.primary.status === 'active'){
                        this.alreadyAccountFlag = true;
                        this.user_name = resp.data.msg.data.acct[0].user;
                        this.primaryDomain = account.primary.domain;
                        return this.addAddonDomains();
                    }
                }else{
                    for(let addon of account.addon){
                        let res = await this.$http.post('email/list-account',{
                            grant_type:'token',
                            domain:addon.domain,
                            searchType:'domain'
                        });
                        if(res.data.msg.data){
                            if(addon.status  === 'active'){
                                this.alreadyAccountFlag = true;
                                this.user_name = res.data.msg.data.acct[0].user;
                                this.primaryDomain = addon.domain;
                                return this.addAddonDomains();
                            }
                        }
                    }
                }
            }
            this.createPrimaryDomainAccount();
        },
        async createPrimaryDomainAccount(){
            let activeDomainFound = false;
            const username = await this.generateUsername();
            for(let account of this.hostingAccounts){
                if(account.primary.status === 'active'){
                    activeDomainFound = true;
                    await this.$store.dispatch("async/stateUpdate", { state: false, text: `Creating email account for  ${account.primary.domain}...` }, { root: true });
                    const resp = await this.$http.post('email/create-account',{
                        grant_type:'token',
                        domain:account.primary.domain,
                        username:username
                    });
                    if(resp.data.msg === 'Account Creation Ok'){
                        this.primaryDomain = account.primary.domain;
                        this.user_name = username;
                        this.addAddonDomains();
                    }else if(resp.data.msg.includes('already exists in the userdata')){
                        await this.$store.dispatch("async/stateUpdate", { state: false, text: `${account.primary.domain} already exists. Finding its owner...` }, { root: true });
                        console.warn('This domain is already under some other domain which is not in WPO. So consider this domain primary for c-panel also... ');
                        this.primaryDomain = account.primary.domain;
                        const ownerResp = await this.$http.post('/email/find-owner', {
                            grant_type: 'token',
                            domain: account.primary.domain
                        });
                        this.user_name = ownerResp.data.split('\n')[1].trim();
                        this.alreadyAccountFlag = true;
                        console.log(this.user_name);
                        this.addAddonDomains();
                    }else{
                        await this.$store.dispatch("async/stateUpdate", { state: true, text: "" }, { root: true });
                        swal('Error', resp.data.msg, 'error');
                    }
                    break;
                }else{
                    for(let addon of account.addon){
                        if(addon.status  === 'active'){
                            activeDomainFound = true;
                            await this.$store.dispatch("async/stateUpdate", { state: false, text: `Creating email account for  ${addon.domain}...` }, { root: true });
                            const resp = await this.$http.post('email/create-account',{
                                grant_type:'token',
                                domain:addon.domain,
                                username:username
                            });
                            if(resp.data.msg === 'Account Creation Ok'){
                                this.primaryDomain = addon.domain;
                                this.user_name = username;
                                this.addAddonDomains();
                            }else if(resp.data.msg.includes('already exists in the userdata')){
                                await this.$store.dispatch("async/stateUpdate", { state: false, text: `${account.primary.domain} already exists. Finding its owner...` }, { root: true });
                                console.warn('This domain is already under some other domain which is not in WPO. So consider this domain primary for c-panel also... ');
                                this.primaryDomain = addon.domain;
                                const ownerResp = await this.$http.post('/email/find-owner', {
                                    grant_type: 'token',
                                    domain: addon.domain
                                });
                                this.user_name = ownerResp.data.split('\n')[1].trim();
                                this.alreadyAccountFlag = true;
                                this.addAddonDomains();
                            }else{
                                await this.$store.dispatch("async/stateUpdate", { state: true, text: "" }, { root: true });
                                swal('Error', resp.data.msg, 'error');
                            }
                            break;
                        }
                    }
                }
            }
            if(!activeDomainFound){
                swal('Error', 'No active Domain Found!', 'error');
                await this.$store.dispatch("async/stateUpdate", { state: true, text: "" }, { root: true });
            }
        },
        async addAddonDomains(){
            let all_domains=[];
            let self = this;
            all_domains.push(this.primaryDomain);
            for(let index in this.hostingAccounts){
                if(this.hostingAccounts[index].primary.domain !== this.primaryDomain && this.hostingAccounts[index].primary.status === 'active'){
                    let newDomain = this.hostingAccounts[index].primary.domain;
                    let splitedArray = newDomain.split('.');
                    let subDomian =splitedArray[0];
                    await this.$store.dispatch("async/stateUpdate", { state: false, text:  `Creating email account for  ${newDomain}...`}, { root: true });
                    await this.$http.post('email/add-addon-domain',{
                        grant_type:'token',
                        newDomain:newDomain,
                        subDomian:subDomian,
                        username:this.user_name
                    });
                    all_domains.push(newDomain);
                }
                for(let addon of this.hostingAccounts[index].addon){
                    if(addon.domain !== this.primaryDomain && addon.status === 'active'){
                        let domain = addon.domain;
                        let splitedDomain = domain.split('.');
                        let sub_domian =splitedDomain[0];
                        await this.$store.dispatch("async/stateUpdate", { state: false, text: `Creating email account for  ${domain}...` }, { root: true });
                        await this.$http.post('email/add-addon-domain',{
                            grant_type:'token',
                            newDomain:domain,
                            subDomian:sub_domian,
                            username:this.user_name
                        });
                        all_domains.push(domain);
                    }
                }
            }
            await db.collection("users").doc(this.uId).update({
                emailSetupFlag: true,
                emailUsernames: {
                    domain:this.primaryDomain,
                    username:this.user_name
                },
                allDomians:all_domains,
            });
            await this.$store.dispatch("async/stateUpdate", { state: true, text: "" }, { root: true });
            setTimeout(function () {
                self.openPopUp();
            },300);
        },
        generateUsername() {
            const characters = 'a-z,A-Z,0-9,#';
            const size = 12;
            let charactersArray = characters.split(',');
            let CharacterSet = '';
            let username = '';

            if( charactersArray.indexOf('a-z') >= 0) {
                CharacterSet += 'abcdefghijklmnopqrstuvwxyz';
            }
            for(let i=0; i < size; i++) {
                username += CharacterSet.charAt(Math.floor(Math.random() * CharacterSet.length));
            }
            return  username;
        }
    }
}
